module.exports = __webpack_public_path__ + "img/offer_icon_clickable.5532c19e.svg";